var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatar = function SvgDefaultAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default-avatar_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 1,
    y: 1,
    fill: "#C4C4C4",
    rx: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#C4C4C4",
    stroke: "#F0F1F2",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M7.207 41.105c2.166-6.27 8.12-10.772 15.126-10.772h5.334c7.006 0 12.961 4.504 15.127 10.774-4.365 4.819-10.66 7.856-17.666 7.893h-.253c-7.007-.037-13.303-3.075-17.668-7.895M16.333 19a8.667 8.667 0 1 1 17.334 0 8.667 8.667 0 0 1-17.334 0",
    clipRule: "evenodd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 1,
    y: 1,
    stroke: "#F0F1F2",
    strokeWidth: 0.5,
    rx: 24
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "default-avatar_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 1,
    y: 1,
    fill: "#fff",
    rx: 24
  })))));
};
export default SvgDefaultAvatar;